<template>
  <div class="d-flex">
    <vs-icon
      icon="search"
      class="cursor-pointer mt-4"
      size="medium"
      v-tooltip="'Ver detalle'"
      @click="showApproval(item.id)"
      data-cy="details"
    />
    <b-dropdown
      variant="light"
      no-caret
      right
    >
      <template #button-content>
        <vs-icon
          icon="more_vert" class="cursor-pointer"
          size="small" v-tooltip="'Administrar'"
          data-cy="gear-button"
        />
      </template>
      <b-dropdown-item
        @click="showBinnacle(item.id)"
        data-cy="approvals-binnacle"
      >
        <vs-icon icon="list" data-cy="approvals-binnacle-icon"/>
        <span> Bitácora </span>
      </b-dropdown-item>
      <b-dropdown-item
        @click="editApproval(item.id)"
        data-cy="approvals-edit"
      >
        <vs-icon icon="edit" data-cy="edit"/>
        <span> Editar aprobaci&oacute;n </span>
      </b-dropdown-item>
      <b-dropdown-item
        @click="duplicateApproval(item.id)"
        data-cy="approvals-duplicate"
      >
        <vs-icon icon="library_add" data-cy="library_add"/>
        <span> Duplicar aprobaci&oacute;n </span>
      </b-dropdown-item>
      <b-dropdown-item
        v-if="!item.in_progress"
        @click="deleteApproval(item.id)"
        data-cy="approvals-delete"
      >
        <vs-icon icon="delete" data-cy="delete"/>
        <span> Eliminar aprobaci&oacute;n </span>
      </b-dropdown-item>
    </b-dropdown>
    <b-modal
      size="xl"
      ref="watchModal"
      hide-footer
      centered
      title="Detalles"
    >
      <div class="scroll">
        <SeeTemplate :approvalId="approvalId"/>
      </div>
    </b-modal>
    <modal-binnacle
      :title="'Bitácora de plantilla de aprobación'"
      ref="modalBinnacle"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import ModalBinnacle from '@/febos/global/binnacles/ModalBinnacle';
import SeeTemplate from '@/febos/chile/approvals/components/templates/SeeTemplate.vue';

export default {
  name: 'TableActions',
  props: ['item', 'fetchTemplates', 'load'],
  components: {
    ModalBinnacle,
    SeeTemplate
  },
  data() {
    return {
      approvalId: null
    };
  },
  methods: {
    ...mapActions('Approvals', [
      'removeApprovalTemplate'
    ]),
    showBinnacle(id) {
      this.$refs.modalBinnacle.show(id);
    },
    showApproval(id) {
      this.approvalId = id;
      this.$refs.watchModal.show();
    },
    editApproval(id) {
      this.$router.push({
        name: 'approval-templates',
        params: { view: 'edit', id, }
      });
    },
    duplicateApproval(id) {
      this.$router.push({
        name: 'approval-templates',
        params: { view: 'duplicate', id, }
      });
    },
    async deleteApproval(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Eliminar plantilla',
        text: '¿Está seguro que deseas borrar permanentemente la plantilla?',
        accept: async () => {
          this.load(true);
          await this.removeApprovalTemplate({
            aprobacionId: id
          });
          await this.fetchTemplates();
          this.$bvToast.toast(
            'Se ha eliminado la plantilla correctamente',
            {
              title: '¡Bien!',
              variant: 'success',
              pauseOnHover: true,
              solid: true,
              noAutoHide: false
            }
          );
          this.load(false);
        },
        cancelText: 'Cancelar',
        acceptText: 'Confirmar'
      });
    }
  }
};
</script>
<style scoped>
.scroll {
  overflow: auto;
  max-height: 750px;
}
td {
  border-bottom: 1px solid #ccc !important; /* or whatever specific values you prefer */
}
</style>
